import { Box } from "@allxsmith/bestax-bulma";
import Spinner from "react-spinner-material";
import React from "react";

export default function LoadingSpinner(){
    return (
      <Box>
        <Spinner
          className="spinner-centre"
          size={120}
          color={"#3273dc"}
          width={2}
        />
      </Box>
    );
}